import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'components/common_v2/loaders';

// see https://github.com/Semantic-Org/Semantic-UI-React/blob/master/src/lib/SUI.js
const Sizes = ['small', 'medium', 'large'];

const FullPageLoader = ({ text, size }) => <Loader active size={size}>{text}</Loader>;

FullPageLoader.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(Sizes)
};

FullPageLoader.defaultProps = {
  text: null,
  size: Sizes[2]
};

export default FullPageLoader;
